import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "form" }
const _hoisted_2 = { class: "form__body" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" New password ")
const _hoisted_4 = { class: "form__footer" }
const _hoisted_5 = { class: "inner" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Cancel ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Save ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("New password")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_textfield = _resolveComponent("ui-textfield")!
  const _component_ui_form_field = _resolveComponent("ui-form-field")!
  const _component_alerts_error = _resolveComponent("alerts-error")!
  const _component_ui_grid_cell = _resolveComponent("ui-grid-cell")!
  const _component_ui_button = _resolveComponent("ui-button")!
  const _component_ui_grid = _resolveComponent("ui-grid")!
  const _component_ui_form = _resolveComponent("ui-form")!
  const _component_ui_list_divider = _resolveComponent("ui-list-divider")!
  const _component_ui_dialog_title = _resolveComponent("ui-dialog-title")!
  const _component_ui_dialog_content = _resolveComponent("ui-dialog-content")!
  const _component_ui_dialog_actions = _resolveComponent("ui-dialog-actions")!
  const _component_ui_dialog = _resolveComponent("ui-dialog")!
  const _component_ui_card = _resolveComponent("ui-card")!

  return (_openBlock(), _createBlock(_component_ui_card, {
    outlined: "",
    class: "card form-wrapper"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_ui_form, {
            nowrap: "",
            "item-margin-bottom": "16"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ui_form_field, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ui_textfield, {
                    modelValue: _ctx.v$.formData.email.$model,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.formData.email.$model) = $event)),
                    modelModifiers: { trim: true },
                    onBlur: _ctx.v$.formData.email.$touch,
                    fullwidth: "",
                    placeholder: "Email",
                    class: _normalizeClass({ 'is-error': _ctx.v$.formData.email.$error })
                  }, null, 8, ["modelValue", "onBlur", "class"])
                ]),
                _: 1
              }),
              (_ctx.v$.formData.email.$error)
                ? (_openBlock(), _createBlock(_component_alerts_error, {
                    key: 0,
                    data: _ctx.v$.formData.email
                  }, null, 8, ["data"]))
                : _createCommentVNode("", true),
              _createVNode(_component_ui_form_field, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ui_grid, { class: "grid grid--width-full grid--padding-none" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ui_grid_cell, {
                        columns: _ctx.isEditSubRoute ? 9 : 12
                      }, {
                        default: _withCtx(() => [
                          (!_ctx.isEditSubRoute)
                            ? (_openBlock(), _createBlock(_component_ui_textfield, {
                                key: 0,
                                modelValue: _ctx.v$.formData.password.$model,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.formData.password.$model) = $event)),
                                modelModifiers: { trim: true },
                                onBlur: _ctx.v$.formData.password.$touch,
                                fullwidth: "",
                                placeholder: "Password",
                                class: _normalizeClass({ 'is-error': _ctx.v$.formData.password.$error }),
                                "input-type": "password"
                              }, null, 8, ["modelValue", "onBlur", "class"]))
                            : (_openBlock(), _createBlock(_component_ui_textfield, {
                                key: 1,
                                "model-value": "'***'",
                                fullwidth: "",
                                placeholder: "Password",
                                value: '***',
                                "input-type": "password",
                                disabled: true
                              }))
                        ]),
                        _: 1
                      }, 8, ["columns"]),
                      (_ctx.isEditSubRoute)
                        ? (_openBlock(), _createBlock(_component_ui_grid_cell, {
                            key: 0,
                            columns: "3",
                            class: "mdc-layout-grid__cell--v-align-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ui_button, {
                                unelevated: "",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modalOpen = true))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_3
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (!_ctx.isEditSubRoute && _ctx.v$.formData.password.$error)
                ? (_openBlock(), _createBlock(_component_alerts_error, {
                    key: 1,
                    data: _ctx.v$.formData.password
                  }, null, 8, ["data"]))
                : _createCommentVNode("", true),
              _createVNode(_component_ui_form_field, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ui_textfield, {
                    modelValue: _ctx.v$.formData.role.$model,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.formData.role.$model) = $event)),
                    modelModifiers: { trim: true },
                    onBlur: _ctx.v$.formData.role.$touch,
                    fullwidth: "",
                    placeholder: "Role",
                    class: _normalizeClass({ 'is-error': _ctx.v$.formData.role.$error })
                  }, null, 8, ["modelValue", "onBlur", "class"])
                ]),
                _: 1
              }),
              (_ctx.v$.formData.role.$error)
                ? (_openBlock(), _createBlock(_component_alerts_error, {
                    key: 2,
                    data: _ctx.v$.formData.role
                  }, null, 8, ["data"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_ui_list_divider),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_ui_button, {
              class: "btn--inline",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.go(-1)))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            _createVNode(_component_ui_button, {
              class: "btn--inline",
              disabled: _ctx.isDisabled,
              raised: "",
              onClick: _ctx.onSave
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ])
        ]),
        _createVNode(_component_ui_dialog, {
          modelValue: _ctx.modalOpen,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modalOpen) = $event)),
          onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.modalOpen = false)),
          onConfirm: _ctx.onConfirm
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ui_dialog_title, null, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_ui_dialog_content, null, {
              default: _withCtx(() => [
                _createVNode(_component_ui_textfield, {
                  modelValue: _ctx.v$.newPassword.password.$model,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.v$.newPassword.password.$model) = $event)),
                  modelModifiers: { trim: true },
                  onBlur: _ctx.v$.newPassword.password.$touch,
                  fullwidth: "",
                  placeholder: "Password",
                  class: _normalizeClass({ 'is-error': _ctx.v$.newPassword.password.$error }),
                  "input-type": "password",
                  ref: "newPassword"
                }, null, 8, ["modelValue", "onBlur", "class"]),
                (_ctx.v$.newPassword.password.$error)
                  ? (_openBlock(), _createBlock(_component_alerts_error, {
                      key: 0,
                      data: _ctx.v$.newPassword.password
                    }, null, 8, ["data"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_ui_dialog_actions)
          ]),
          _: 1
        }, 8, ["modelValue", "onConfirm"])
      ])
    ]),
    _: 1
  }))
}